<template>
	<div class="ProvisioningStatus" :class="{ compact }" v-if="state">
		<span v-if="label" class="label">{{ label }}:</span>
		<v-chip size="small" data-cy="provisioningStatusChip" :color="color">{{ statusText }}</v-chip>
		<span v-if="state.error && !compact" class="error-text">{{ state.error }}</span>
		<template v-if="state.status === 'failed'">
			<!-- compact sits in a section header next to chip + toggle: icon only, label as tooltip -->
			<v-tooltip v-if="compact" :text="$t('text.retryProvisioning')" location="top">
				<template #activator="{ props: tooltipProps }">
					<v-btn v-bind="tooltipProps" icon size="x-small" variant="outlined" data-cy="retryProvisioningButton" @click="$emit('retry')">
						<v-icon>mdi-refresh</v-icon>
					</v-btn>
				</template>
			</v-tooltip>
			<v-btn v-else size="x-small" variant="outlined" data-cy="retryProvisioningButton" @click="$emit('retry')">
				<v-icon start>mdi-refresh</v-icon>{{ $t('text.retryProvisioning') }}
			</v-btn>
		</template>
	</div>
</template>

<script>
export default {
	name: 'ProvisioningStatus',
	props: {
		state: { type: Object, default: null },
		label: { type: String, default: '' },
		// header-accessory mode: chip + retry only, the error text is rendered by the host
		compact: { type: Boolean, default: false },
	},
	emits: [ 'retry' ],
	computed: {
		color() {
			return this.state?.status === 'provisioned' ? 'green' : this.state?.status === 'failed' ? 'red' : 'grey'
		},
		statusText() {
			// literal keys so the find-missing-translations scanner can see them
			const texts = {
				provisioned: this.$t('text.provisioningProvisioned'),
				failed: this.$t('text.provisioningFailed'),
				pending: this.$t('text.provisioningPending'),
			}
			return texts[this.state?.status] ?? texts.pending
		},
	},
}
</script>

<style scoped>
.ProvisioningStatus { margin-top: 6px; display: flex; align-items: center; gap: 8px; }
.ProvisioningStatus.compact { margin-top: 0; }
.label { font-size: 12px; color: #666; }
.error-text { font-size: 11px; color: #b00020; }
</style>
